import styles from "./ArticleLeadArt.module.scss";
import { ArticleLeadArtFragment } from "types/api";
import Image from "components/Image";
import IFrame from "components/IFrame";
import gql from "graphql-tag";

const ArticleLeadArt = ({ ...props }: ArticleLeadArtFragment) => {
  return (
    <div className={styles.root}>
      {props.__typename === "LeadArtImage" && props.image && (
        <figure className={styles.figure}>
          <div className={styles.media}>
            <Image
              src={props.image.url}
              srcSet={props.image.srcSet || undefined}
              width={props.image.width}
              height={props.image.height}
              alt={props.image.altText || ""}
              lazy={false}
            />
          </div>
          <figcaption className={styles.credit}>
            {props.image.captionText && (
              <span className={styles.caption}>{props.image.captionText}</span>
            )}
            {props.image.attributionText && (
              <span className={styles.attribution}>
                {props.image.attributionUrl ? (
                  <a href={props.image.attributionUrl} className={styles.link}>
                    {props.image.attributionText}
                  </a>
                ) : (
                  props.image.attributionText
                )}
              </span>
            )}
          </figcaption>
        </figure>
      )}
      {props.__typename === "Cinemagraph" && (
        <figure className={styles.figure}>
          <div className={styles.media}>
            <video
              className={styles.video}
              autoPlay={true}
              loop={true}
              muted={true}
              playsInline={true}
              poster={props.poster?.url || ""}
            >
              {props.formats
                ?.sort((a, b) => {
                  // H264 is the slowest option, so should be last
                  return a.encoding === "H264" ? 1 : -1;
                })
                .map((format) => {
                  return (
                    format?.encoding &&
                    format.url && (
                      <source
                        key={`lead-art-${format.encoding}`}
                        src={format.url}
                        type={
                          (format.encoding === "H264" &&
                            "video/mp4; codecs=avc1") ||
                          (format.encoding === "VP9" &&
                            "video/webm; codecs=vp9") ||
                          (format.encoding === "HEVC" &&
                            "video/mp4; codecs=hvc1") ||
                          ""
                        }
                      />
                    )
                  );
                })}
            </video>
          </div>
          <figcaption className={styles.credit}>
            {props.captionText && (
              <span className={styles.caption}>{props.captionText}</span>
            )}
            {props.attributionText && (
              <span className={styles.attribution}>
                {props.attributionText}
              </span>
            )}
          </figcaption>
        </figure>
      )}
      {props.__typename === "LeadArtEmbed" && (
        <figure className={styles.figure}>
          <IFrame
            src={props.src}
            width={props.width}
            height={props.height}
            title="Embedded interactive content"
          />
          {props.caption && (
            <span className={styles.caption}>
              <figcaption>{props.caption}</figcaption>
            </span>
          )}
        </figure>
      )}
    </div>
  );
};

ArticleLeadArt.fragment = gql`
  fragment articleLeadArt on LeadArt {
    ... on LeadArtImage {
      image(width: 720, height: 405, sizes: ["1x", "2x"]) {
        url
        width
        height
        srcSet
        captionText
        attributionText
        attributionUrl
        altText
      }
    }
    ... on Cinemagraph {
      attributionText
      captionText
      formats {
        encoding
        url
      }
      poster(width: 720, height: 405) {
        url
      }
    }
    ... on LeadArtEmbed {
      src
      width
      height
      caption
    }
  }
`;

export default ArticleLeadArt;
